export default theme => ({
    button: {
        '&.MuiButton-root': {
            border: '1px solid #006AC3',
            borderRadius: '4px',
            boxSizing: 'border-box',
            height: '40px'
        }
    },
    gridContainerCenter: {
        display: 'flex',
        justifyContent: 'center'
    },
    ssoErrorRoot: {
        padding: theme.spacing(12, 4, 4, 4)
    }
})
